module.exports = __webpack_public_path__ + "media/images/about---cb2a9c72.jpg";